import loadable from "@loadable/component"

export const AccountSettingsWrapper = loadable(
    () => import('./AccountSettings')
)
export type {AccountSettingsProps} from './AccountSettings'